import { Dayjs } from "dayjs";
import { FdpInvoiceListDataArgs } from "../../../pages/fdp/invoices/FdpInvoiceConstants";
import {
  CiEditListReponse,
  ClientInvoiceWithDateRangeUIResponse,
  FdpInvoiceCommentUIResponse,
  FdpInvoiceListUIResponse,
  RatecardFdpInvoiceUIResponse,
  TripAndDateRangeDataForSelectedStoresUIResponse,
} from "../../models/ApiResponse";
import { axiosRequests } from "../axiosRequest";
import { FdpInvoiceCommentRequest } from "../../models/requestModels/ClientInvoiceRequests";

const INVOICE_MANAGER_ENDPOINT = "fdc-invoice";
export const FdpInvoiceAgent = {
  getFdpInvoiceList: (fdpId: number, args: FdpInvoiceListDataArgs) =>
    axiosRequests.getWithQueryParam<FdpInvoiceListUIResponse>(
      `${INVOICE_MANAGER_ENDPOINT}/fdp-invoices/fdp/${fdpId}`,
      {
        params: {
          pageIndex: args.pageIndex,
          pageSize: args.pageSize,
        },
      }
    ),
  fetchFdpInvoiceFile: (invoicePkId: number, invoiceStatus: string) =>
    axiosRequests.getWithQueryParamAndReturnBlob<Blob>(
      `${INVOICE_MANAGER_ENDPOINT}/fdp-invoices/${invoicePkId}/${invoiceStatus}/download-file`,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/pdf",
          Accept: "application/pdf",
        },
      }
    ),
  changeInvoiceStatus: (
    invoiceId: number,
    invoiceStatus: string,
    timestamp: Dayjs | null = null
  ) =>
    axiosRequests.put<RatecardFdpInvoiceUIResponse>(
      `${INVOICE_MANAGER_ENDPOINT}/fdp-invoices/change/status/${invoiceId}`,
      { invoiceStatus: invoiceStatus, timestamp: timestamp }
    ),
  saveFdpReceiptFile: (invoicePkId: number, formData: FormData) =>
    axiosRequests.postWithFormData<string>(
      `${INVOICE_MANAGER_ENDPOINT}/fdp-invoices/upload/receipt/${invoicePkId}`,
      formData
    ),
  getFdpInvoiceComments: (invoicePkId: number) =>
    axiosRequests.getWithQueryParam<FdpInvoiceCommentUIResponse>(
      `${INVOICE_MANAGER_ENDPOINT}/comment/all-comments`,
      {
        params: {
          invoicePkId: invoicePkId,
        },
      }
    ),
  addFdpInvoiceComment: (commentRequest: FdpInvoiceCommentRequest) =>
    axiosRequests.post<FdpInvoiceCommentUIResponse>(
      `${INVOICE_MANAGER_ENDPOINT}/comment/add-comment`,
      commentRequest
    ),
  editFdpInvoiceComment: (commentRequest: FdpInvoiceCommentRequest) =>
    axiosRequests.post<FdpInvoiceCommentUIResponse>(
      `${INVOICE_MANAGER_ENDPOINT}/comment/edit-comment`,
      commentRequest
    ),
  deleteFdpInvoiceComment: (commentId: number) =>
    axiosRequests.deleteWithQueryParam<FdpInvoiceCommentUIResponse>(
      `${INVOICE_MANAGER_ENDPOINT}/comment/delete-comment`,
      {
        params: {
          commentId: commentId,
        },
      }
    ),
  getTripAndDateRangeForSelectedStores: (
    fdpInvoiceId: string,
    storeIds: string
  ) =>
    axiosRequests.getWithQueryParam<TripAndDateRangeDataForSelectedStoresUIResponse>(
      `${INVOICE_MANAGER_ENDPOINT}/fdp-invoices/get-trip-and-date-range-for-selected-stores`,
      {
        params: {
          fdpInvoiceId: fdpInvoiceId,
          storeIds: storeIds,
        },
      }
    ),
  getClientsWithDateRanges: (invoiceId: number) =>
    axiosRequests.getWithQueryParam<ClientInvoiceWithDateRangeUIResponse>(
      `${INVOICE_MANAGER_ENDPOINT}/fdp-invoices/get-clients-with-date-ranges`,
      {
        params: {
          invoiceId: invoiceId,
        },
      }
    ),
  fetchAllEditLists: (invoiceId: number, fdpId: number) =>
    axiosRequests.getWithQueryParam<CiEditListReponse>(
      `${INVOICE_MANAGER_ENDPOINT}/fdp-invoices/fetch-all-edits/${invoiceId}`,
      {
        params: {
          fdp_id: fdpId,
        },
      }
    ),
    fetchFdpInvoiceFileCsv: (invoicePkId: number, invoiceStatus: string) =>
    axiosRequests.getWithQueryParamAndReturnBlob<Blob>(
      `${INVOICE_MANAGER_ENDPOINT}/fdp-invoices/${invoicePkId}/${invoiceStatus}/download-file/excel`,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/pdf",
          Accept: "application/pdf",
        },
      }
    ),
};
